module.exports = __webpack_public_path__ + "static/sapientia-e8c1f46d22d55cbe5dfd31f16b87ea0b.svg";